<div class="message-avatar" (click)="goToProfile()" style="background-image: url({{ avatarImage }});"></div>
